import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@app/shared/pipes/pipes.module';
import { ProductModule } from '@app/shared/product/product.module';
import { ReviewModule } from '@app/shared/review/review.module';
import { AnimatedHandModule } from '@app/shared/ui/animated-hand/animated-hand.module';
import { ListModule } from '@app/shared/ux/lists/list.module';
import { WucPictureModule } from '@inshared/website-ui-components';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { CarouselModule } from 'outshared-lib';
import { ButtonSeparatorModule } from './button-separator/button-separator.module';
import { CardModule } from './card/card.module';
import { CompareTableModule } from './compare-insurances/compare-table.module';
import { ContactCardContentComponent } from './contact-card/contact-card-content.component';
import { ContactCardHeaderComponent } from './contact-card/contact-card-header.component';
import { ContactCardOverlayComponent } from './contact-card/contact-card-overlay.component';
import { ContactCardComponent } from './contact-card/contact-card.component';
import { DeckComponent } from './deck/deck.component';
import { DividerModule } from './divider/divider.module';
import { FloatingArrowModule } from './floating-arrow/floating-arrow.module';
import { FunnelEntryStickyModule } from './funnel-entry-sticky/funnel-entry-sticky.module';
import { FunnelEntryModule } from './funnel-entry/funnel-entry.module';
import { GradeTitleModule } from './grade-title/grade-title.module';
import { HandToButtonModule } from './hand-to-button/hand-to-button.module';
import { HeroContentModule } from './hero-content/hero-content.module';
import { HeroHeaderModule } from './hero-header/hero-header.module';
import { IntroModule } from './intro/intro.module';
import { KnowledgeBaseCarouselModule } from './knowledge-base-carousel/knowledge-base-carousel.module';
import { KnowledgeArticleCardsCarouselModule } from './knowledgebase-article-cards/knowledgebase-article-cards.module';
import { KnowledgeArticleListModule } from './knowledgebase-article-list/knowledgebase-article-list.module';
import { NavigationIconModule } from './navigation-icon/navigation-icon.module';
import { ProductHeaderModule } from './product-header/product-header.module';
import { QuoteModule } from './quote/quote.module';
import { ReviewSidebarModule } from './review-sidebar/review-sidebar.module';
import { ReviewSectionModule } from './sections/ins-review-section/review-section.module';
import { SeoPageHeaderModule } from './seo-page-header/seo-page-header.module';
import { StappenModule } from './stappen/stappen.module';
import { StickyBarModule } from './sticky-bar/sticky-bar.module';
import { SubproductHeaderModule } from './subproduct-header/subproduct-header.module';
import { UspsModule } from './usp/usps.module';

@NgModule({
    imports: [
        AnimatedHandModule,
        ButtonSeparatorModule,
        CardModule,
        CarouselModule,
        CommonModule,
        CompareTableModule,
        FloatingArrowModule,
        FunnelEntryModule,
        FunnelEntryStickyModule,
        HeroContentModule,
        HeroHeaderModule,
        LazyLoadImageModule,
        PipesModule,
        ProductHeaderModule,
        ProductModule,
        ReviewModule,
        ReviewSectionModule,
        ReviewSidebarModule,
        RouterModule,
        StappenModule,
        SubproductHeaderModule,
        UspsModule,
        ListModule,
        WucPictureModule,
        SeoPageHeaderModule,
        KnowledgeArticleCardsCarouselModule,
        KnowledgeArticleListModule,
        NavigationIconModule,
    ],
    declarations: [
        ContactCardComponent,
        ContactCardContentComponent,
        ContactCardHeaderComponent,
        ContactCardOverlayComponent,
        DeckComponent,
    ],
    exports: [
        ButtonSeparatorModule,
        CardModule,
        CompareTableModule,
        ContactCardComponent,
        ContactCardContentComponent,
        ContactCardHeaderComponent,
        ContactCardOverlayComponent,
        DeckComponent,
        DividerModule,
        FloatingArrowModule,
        FunnelEntryModule,
        FunnelEntryStickyModule,
        GradeTitleModule,
        HandToButtonModule,
        HeroContentModule,
        HeroHeaderModule,
        IntroModule,
        KnowledgeBaseCarouselModule,
        ProductHeaderModule,
        QuoteModule,
        ReviewSectionModule,
        ReviewSidebarModule,
        StappenModule,
        StickyBarModule,
        SubproductHeaderModule,
        UspsModule,
        SeoPageHeaderModule,
        KnowledgeArticleCardsCarouselModule,
        KnowledgeArticleListModule,
    ],
})
export class ContentSharedModule {
}
